import React from "react";

/**
 * Shared empty-state for Settings → master database lists
 * (Admin Users, Doctors, Treatments, Medicines, Labs, Lab Works).
 *
 * Monochrome, muted `text-darkgrey` at 60% — same visual language as
 * the Payments / Labs / Prescriptions / Expenses v2 empty states in
 * the app. The illustration is a stylised filing-cabinet so it reads
 * as "master data" across every master it's used on, avoiding
 * per-module glyphs for what is conceptually the same concept.
 */
const CabinetIllustration = () => (
  <svg
    viewBox="0 0 120 140"
    className="w-[150px] h-[150px] text-darkgrey opacity-60"
    aria-hidden="true"
  >
    {/* Cabinet body */}
    <rect
      x="24"
      y="20"
      width="72"
      height="100"
      rx="6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
    />
    {/* Three drawers */}
    <line x1="24" y1="52" x2="96" y2="52" stroke="currentColor" strokeWidth="1.4" />
    <line x1="24" y1="84" x2="96" y2="84" stroke="currentColor" strokeWidth="1.4" />
    {/* Drawer handles */}
    <rect x="52" y="34" width="16" height="4" rx="2" fill="currentColor" />
    <rect x="52" y="66" width="16" height="4" rx="2" fill="currentColor" />
    <rect x="52" y="98" width="16" height="4" rx="2" fill="currentColor" />
    {/* Drawer labels (subtle rectangles) */}
    <rect x="32" y="30" width="16" height="10" rx="2" fill="currentColor" fillOpacity="0.2" />
    <rect x="32" y="62" width="16" height="10" rx="2" fill="currentColor" fillOpacity="0.2" />
    <rect x="32" y="94" width="16" height="10" rx="2" fill="currentColor" fillOpacity="0.2" />
  </svg>
);

const SettingsEmptyState = ({ label = "No Data Found" }) => (
  <div className="flex flex-col items-center justify-center py-10 gap-2 text-darkgrey select-none">
    <CabinetIllustration />
    <p className="text-bodyBB opacity-60">{label}</p>
  </div>
);

export default SettingsEmptyState;
